import React, { useEffect, useRef, useState } from 'react';
import './CardCarousel.css'; // Import the CSS file
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import Slider from "react-slick" 
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const CardCarousel = ({ museums }) => {
  const [slideIndex, setSlideIndex] = useState(0);
  const [width, setWidth] = useState(window.innerWidth)

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: width > 600 ? 2 : 1,
    slidesToScroll: width > 600 ? 2 : 1,
    beforeChange: (current, next) => setSlideIndex(next)
  };

  let sliderRef = useRef(null);

  useEffect(() => {
    //Handle Responsiveness  
    const handleResize = () => {
      setWidth(window.innerWidth)
    }

    handleResize()

    // Bind the event listener
    window.addEventListener('resize', handleResize)

    return () => {
      // Unbind the event listener on clean up
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const StyledSlider = styled(Slider)`
    @media only screen and (max-width: 600px) {
      .slick-list {
        overflow: visible !important
      }
    }
  `;
  
  return (
    <div className="cardCarouselContainer">
      <StyledSlider
        ref={slider => {
          sliderRef = slider;
        }}
        {...settings}
      >
        {museums.map((museum, index) => (
          <Link key={index} to={`/museums/${museum.id}`}>
            <div className="carouselCardItem">
              <img
                className="cardCarouselImage"
                src={museum.main_image}
                alt={`Slide ${index + 1}`}
              />
              <h3 className="carouselCardTitle">{museum.name}</h3>
              <div className="carouselCardDescription" dangerouslySetInnerHTML={{__html: museum.main_info}}></div>
            </div>
          </Link>
        ))}
      </StyledSlider>
      
      {width > 1200 && 
        <div className="cardCarouselArrowContainer">
          <div
            className="cardCarouseCustomArrow"
            onClick={e => sliderRef.slickGoTo(slideIndex - 1)}
          >
            <FaChevronLeft /> 
          </div>
          <div
            className="cardCarouseCustomArrow"
            onClick={e => sliderRef.slickGoTo(slideIndex + 1)}
          >
            <FaChevronRight />
          </div>
        </div>
      }
    </div>
  );
};

export default CardCarousel;
